/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MinimalProductDto
 */
export interface MinimalProductDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    logoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    branchLabel: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    subBranchLabel: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalProductDto
     */
    ownerName: string;
    /**
     * 
     * @type {number}
     * @memberof MinimalProductDto
     */
    activeContractsCount: number;
    /**
     * 
     * @type {number}
     * @memberof MinimalProductDto
     */
    quotesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalProductDto
     */
    isTacitRenewal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalProductDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MinimalProductDto
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof MinimalProductDto
     */
    lastModificationDate?: Date;
}

/**
 * Check if a given object implements the MinimalProductDto interface.
 */
export function instanceOfMinimalProductDto(value: object): value is MinimalProductDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('branchLabel' in value) || value['branchLabel'] === undefined) return false;
    if (!('subBranchLabel' in value) || value['subBranchLabel'] === undefined) return false;
    if (!('ownerName' in value) || value['ownerName'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('isTacitRenewal' in value) || value['isTacitRenewal'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function MinimalProductDtoFromJSON(json: any): MinimalProductDto {
    return MinimalProductDtoFromJSONTyped(json, false);
}

export function MinimalProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinimalProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'code': json['code'],
        'logoURL': json['logoURL'] == null ? undefined : json['logoURL'],
        'branchLabel': json['branchLabel'],
        'subBranchLabel': json['subBranchLabel'],
        'ownerName': json['ownerName'],
        'activeContractsCount': json['activeContractsCount'],
        'quotesCount': json['quotesCount'],
        'isTacitRenewal': json['isTacitRenewal'],
        'isActive': json['isActive'],
        'creationDate': (new Date(json['creationDate'])),
        'lastModificationDate': json['lastModificationDate'] == null ? undefined : (new Date(json['lastModificationDate'])),
    };
}

export function MinimalProductDtoToJSON(json: any): MinimalProductDto {
    return MinimalProductDtoToJSONTyped(json, false);
}

export function MinimalProductDtoToJSONTyped(value?: MinimalProductDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'code': value['code'],
        'logoURL': value['logoURL'],
        'branchLabel': value['branchLabel'],
        'subBranchLabel': value['subBranchLabel'],
        'ownerName': value['ownerName'],
        'activeContractsCount': value['activeContractsCount'],
        'quotesCount': value['quotesCount'],
        'isTacitRenewal': value['isTacitRenewal'],
        'isActive': value['isActive'],
        'creationDate': ((value['creationDate']).toISOString()),
        'lastModificationDate': value['lastModificationDate'] == null ? undefined : ((value['lastModificationDate']).toISOString()),
    };
}

